import { useState } from 'react';
import { useQuery } from 'react-query'
import { Card, Row, Form, Col, Select, Image, Carousel } from "antd"
import EndPoints from '../../shared/endPoints/EndPoints.json';
import useHttpClient from '../../shared/sendRequest/useHttpClient'
import instructions from '../../assets/Οδηγίες Εγκατάστασης ShortDrive - Ενημερωτικό Ένθετο.pdf'


export default function InstallationGuide() {
    const [marqueId, setMarqueId] = useState(null)
    const [modelId, setModelId] = useState(null)
    const [form] = Form.useForm();
    const { sendRequest } = useHttpClient()


    const formItemLayout = {
        labelCol: {
            span: 10,
        },
        wrapperCol: {
            span: 8
        },
    };

    const { data: marques } = useQuery('getmarques', async () => sendRequest({
        endpoint: `${EndPoints.BASEURL + EndPoints.OBDGUIDE.GETMARQUES}`,
        method: 'GET',
    }))

    const { data: models } = useQuery(['getmodels', { marqueId }], async () => sendRequest({
        endpoint: `${EndPoints.BASEURL}${EndPoints.OBDGUIDE.GETMODELS}?MarqueId=${marqueId}`,
        method: 'GET',
    }), { enabled: !!marqueId })

    const { data: photos } = useQuery(['getphotos', { modelId }], async () => sendRequest({
        endpoint: `${EndPoints.BASEURL}${EndPoints.OBDGUIDE.GETPHOTOS}?ModelId=${modelId}`,
        method: 'GET',
    }), { enabled: !!modelId })

    return (
        <><Card type="inner">
            <Form form={form} {...formItemLayout}>

                <Row justify="center">
                    <Col span={12}>
                        <Form.Item name="marque" label="Μάρκα:">
                            <Select onChange={(id) => { form.setFieldsValue({ 'model': undefined }); setMarqueId(id); } }>
                                {marques?.map((marque) => <Select.Option key={marque.marque} value={marque.id}>{marque.marque}</Select.Option>)}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Row justify="center">
                    <Col span={12}>
                        <Form.Item name="model" label="Μοντέλο:">
                            <Select onChange={(id) => setModelId(id)}>
                                {models?.map((model) => <Select.Option key={model.model} value={model.id}>{model.model}</Select.Option>)}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                {photos ? (
                    <Row justify="center">
                        <Col xs={24} lg={10}>
                            <Carousel dotPosition="top">
                                {Object.keys(photos).map((key) => photos[key] ? <Image src={photos[key]} fluid /> : null)}
                            </Carousel>
                        </Col>
                    </Row>) : null}
            </Form>
        </Card><Row justify="center">
                <Col span={12}>
                    <a href={instructions} download="Οδηγίες Εγκατάστασης ShortDrive - Ενημερωτικό Ένθετο.pdf"><Col>Οδηγίες Εγκατάστασης ShortDrive - Ενημερωτικό Ένθετο</Col></a>
                    <embed src={instructions} width="100%" height="2100px" />
                </Col>
            </Row></>    
        )
}